module.exports = __webpack_public_path__ + "static/wave-beige-ea992ee3a0db65d33bcbc69e5406bd91.png";